// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"521":"f54580c2","941":"ae83b9a4"}[chunkId] + ".css";
};